import React, { useState, useEffect } from 'react';
import TextField from './MaterialUi/TextField';
import styles from './PropertyMessageMessage.scss';

// export const STEP1 = 'step-one';

const PropertyMessageMessage = ({ defaultMessage, successHandler = null, vertical = false }) => {
    const [message, setMessage] = useState('');

    useEffect(() => {
        // set defaultMessage asyncron to resize Textarea to correct size
        setMessage(defaultMessage);
    }, []);

    // const data = getData('step1') || {};
    const handleChange = (ev: React.FormEvent) => {
        const elm = ev.currentTarget as HTMLInputElement;
        setMessage(elm.value);
    };

    return (
        <div className={styles.propertyMessageMessage}>
            <p>Hilf dem Anbieter, sich ein Bild von Dir zu machen und gib ihm Informationen zu Dir und Deiner Lebenssituation.</p>
            <TextField
                multiline
                minRows={5}
                maxRows={10}
                required={true}
                aria-required="true"
                name="message"
                label="Nachricht an den Anbieter"
                value={message}
                inputProps={{
                    maxLength: 4000,
                }}
                onChange={handleChange}
                helperText={message.length >= 4000 ? 'Maximale Zeichenzahl von 4000 Zeichen erreicht.' : null}
            />
        </div>
    );
};

export default PropertyMessageMessage;
